import { rbcHtsAssistApi } from "@b2bportal/rbc-hts-assist-api";
import type { ChatWidgetConfig } from "@hopper-ai/chat-widget";
import { axiosInstance } from "@hopper-b2b/api";

export const submitHtsAssistCsat: NonNullable<
  NonNullable<ChatWidgetConfig["csat"]>["onSubmit"]
> = async ({ conversationId, rating, feedback }) => {
  await rbcHtsAssistApi(axiosInstance).apiV0HtsAssistCsatPost({
    conversationId,
    csatScore: rating,
    ...(feedback ? { csatComment: feedback } : {}),
  });
};
